import { render, staticRenderFns } from "./Workflows.vue?vue&type=template&id=367fa1f9&"
import script from "./Workflows.vue?vue&type=script&lang=js&"
export * from "./Workflows.vue?vue&type=script&lang=js&"
import style0 from "./Workflows.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports